export default __webpack_public_path__ + "static/media/logo-proyecto-nahual.be8244a5.webp";